<div [ngStyle]="{borderLeftColor:color}" class="container">
    <div class="title">
        <p class="title-data">
            <ng-container *ngIf="!loading">
                <span class="value" [nTextTips]="value">{{value}}</span><span class=unit>{{unit}}</span>
            </ng-container>
            <app-skeleton *ngIf="loading" height="1.4em" style="margin-bottom: 2px" width="100px"></app-skeleton>
        </p>
        <p class="title-name">{{title}}</p>
    </div>
    <div *ngIf="!loading && data.indicator && data.indicator_values.length" class="chart">
        <n-chart #chartComponent
            [option]="echartsOption"
            style="height: 100%; width: 100%;overflow: visible"></n-chart>
    </div>
    <div *ngIf="loading" class="chart">
        <app-skeleton
            style="padding: 5px 10px;">
        </app-skeleton>
    </div>
    <div *ngIf="!loading && (!data.indicator || !data.indicator_values.length)" class="chart no-chart-data">
        {{i18n.get('monitor.recentTasks_result_noData')}}
    </div>
</div>
